import './styles.scss'
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { I18n } from 'react-redux-i18n'

import { updateCurrentProcess, partialUpdateProcess } from 'redux/smartchat/header/actions'
import { DotsOptionsSelector, InputControls } from 'components/common'
import { getStaticImage } from 'utils/statics'
import { getHexLuminance } from 'utils'

const ProcessItem = ({ process, categoryColor, toggleProcessCalledFromModal, toggleProcessModal, toggleDeleteProcessModal, toggleProcessNotificationModal }) => {
  const { currentProcess, labelsList, modalLoading } = useSelector(store => store.smartchatHeader)
  const dispatch = useDispatch()
  const [isOpenOptionsSelector, setIsOpenOptionsSelector] = useState(false)
  const selectorOptions = (process.isDefault || process.processType === 'conversational') ? [
    {
      name: I18n.t('dashboard_edit-process'),
      onClick: () => {
        toggleOptionsSelector()
        toggleProcessModal({ mode: 'update', processId: process._id, processType: process.processType })
      }
    }
  ] : [
    {
      name: I18n.t('dashboard_edit-process'),
      onClick: () => {
        toggleOptionsSelector()
        toggleProcessModal({ mode: 'update', processId: process._id, processType: process.processType })
      }
    },
    {
      name: I18n.t('dashboard_delete-process'),
      fontColor: 'red',
      onClick: () => {
        toggleOptionsSelector()
        toggleDeleteProcessModal({ processId: process._id })
      }
    }
  ]

  const toggleOptionsSelector = () => setIsOpenOptionsSelector(!isOpenOptionsSelector)

  return (
    <div
      className={`
        process-list__process-item
        ${process._id === currentProcess ? 'process-list__process-item--active' : ''}
      `}
      style={{ backgroundColor: process.processColor ? process.processColor : null }}
    >
      <div className='process-list__process-item-level'>
        <div
          className='process-list__process-item-level-bar'
          style={{ backgroundColor: categoryColor }}
        ></div>
        <button
          style={{
            color: (!categoryColor || getHexLuminance(categoryColor) > 0.4) ? '#333333' : null,
            backgroundColor: categoryColor
          }}
          onClick={process.calledFrom?.length ? () => toggleProcessCalledFromModal(process.calledFrom) : null}
        >
          {process.calledFrom?.length || 0}
        </button>
      </div>
      <div className='process-list__process-item-title-container'>
        <p
          className='process-list__process-item-title text-ellipsis'
          title={process.processName}
          style={{ color: (!process.processColor || getHexLuminance(process.processColor) > 0.4) ? '#333333' : null }}
          onClick={() => dispatch(updateCurrentProcess(process._id))}
        >
          {process.processName}
        </p>
        {process.labels?.length > 0 && (
          <div className='process-list__process-item-labels'>
            {process.labels.map((labelId, index) => {
              if ((process.processErrors && index > 1) || index > 2 ) return null

              const label = labelsList.find(label => label._id === labelId)
              if (!label) return null

              return (
                <span
                  key={index}
                  className='process-list__process-item-label text-ellipsis'
                  style={{
                    color: (!label.color || getHexLuminance(label.color) > 0.4) ? '#333333' : null,
                    backgroundColor: label.color
                  }}
                >
                  {label.name}
                </span>
              )
            })}
          </div>
        )}
      </div>
      {process.processErrors && (
        <figure
          className='process-list__process-item-warning'
          data-for={`warning-tooltip-${process._id}`}
          data-tip={I18n.t('smartchat_tooltip_process_warning')}
        >
          <img src={getStaticImage('/icons/orange-brand/icon-warning-gray-white.svg')} alt='Warning' />
        </figure>
      )}
      <div className='process-list__process-item-options-container'>
        <DotsOptionsSelector
          className='process-list__process-item-options-selector'
          isOpen={isOpenOptionsSelector}
          toggle={toggleOptionsSelector}
          options={selectorOptions}
          position='top'
          dotsColor={(!process.processColor || getHexLuminance(process.processColor) > 0.4) ? '#E87721' : '#ffffff'}
        />
        {!process.isDefault && (
          <InputControls
            injectType='external'
            className='process-list__process-item-switch'
            value={process.isActive}
            onChange={value => dispatch(partialUpdateProcess({
              processId: process._id,
              data: { isActive: value },
              refresh: true,
              onFinishNotification: toggleProcessNotificationModal
            }))}
            loading={modalLoading}
            color={(!process.processColor || getHexLuminance(process.processColor) > 0.4) ? 'primary' : 'light'}
          />
        )}
      </div>
      <ReactTooltip id={`warning-tooltip-${process._id}`} effect='solid' html={true} />
    </div>
  )
}

export default ProcessItem
